module.exports = __webpack_public_path__ + "images/hummer0c60c96a535335da37077955c841ec12.png";